















import { Vue, Component, Prop } from 'vue-property-decorator';
import Button from '@/components/atoms/Button/Button.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import AppleLogo from '@/components/icons/AppleLogo.vue';
import GoogleLogo from '@/components/icons/GoogleLogo.vue';

export enum EAvailableProviders {
  apple = 'apple',
  google = 'google'
}

const availableProviders = [
  {
    displayName: 'Google',
    slug: EAvailableProviders.google,
    icon: GoogleLogo
  },
  {
    displayName: 'Apple',
    slug: EAvailableProviders.apple,
    icon: AppleLogo
  }
];

@Component({
  components: {
    Typography,
    Button,
    GoogleLogo,
    AppleLogo
  }
})
export default class ProviderButton extends Vue {
  @Prop({ required: true }) readonly provider!: EAvailableProviders;
  @Prop(String) readonly label!: string;
  @Prop(Boolean) readonly small!: boolean;
  @Prop(Boolean) readonly signup!: boolean;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly loading!: boolean;
  @Prop(String) readonly loadingLabel!: string;

  get labelValue() {
    if (!this.label && this.providerData) {
      return `${this.providerData.displayName}`;
    }

    return this.label;
  }

  get providerData() {
    return availableProviders.find(provider => provider.slug === this.provider);
  }
}
